import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/empresas/perimetros-de-comercio-informal/';

/**
 * GET Perimetros
 * @returns {Promise<Array<object>>}
 */
export const getPerimetros = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Perimetro
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPerimetro = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Perimetro
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPerimetro = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Perimetro
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPerimetro = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Perimetro
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePerimetro = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
